import React from "react"
import { OgTags } from "../components/OpenGraph";
import Header from "../components/Header"
import Footer from "../components/Footer"
import Brands from "../components/Brands"
import Services from "../components/Services"
import SampleWorks from "../components/SampleWorks"
import Testimonials from "../components/Testimonials"
import Plan from "../components/Plan"
import ContentImage from "../components/ContentImage"

const logo = [
  {
    name: 'Crafters',
    image: require('../assets/svg/brands-crafters-companion-logo.svg')
  }, {
    name: 'Cyber Talks',
    image: require('../assets/svg/brands-cybertalks-logo.svg')
  }, {
    name: 'Go Page',
    image: require('../assets/svg/brands-gopage-logo.svg')
  }, {
    name: 'Life Grip',
    image: require('../assets/svg/brands-lifegrip-logo.svg')
  }, {
    name: 'On Target',
    image: require('../assets/svg/brands-ontarget-logo.svg')
  }
]

const servicesInfo = [
  {
    image: require('../assets/images/web.png'),
    desc: 'Inbox, calendar & appointment management'
  }, {
    image: require('../assets/images/social.png'),
    desc: 'Social media management, lead generation & telemarketing'
  }, {
    image: require('../assets/images/services-img8.png'),
    desc: 'Website, content & e-commerce management'
  }, {
    image: require('../assets/images/services-img11.png'),
    desc: 'Accounting, bookkeeping & administrative support'
  }, {
    image: require('../assets/images/services-img7.png'),
    desc: 'Data entry, document typing & digitization'
  }, {
    image: require('../assets/images/presentations.png'),
    desc: 'Expense tracking, reporting & invoicing'
  }, {
    image: require('../assets/images/services-img5.png'),
    desc: 'Online research, surveys & data processing'
  }, {
    image: require('../assets/images/services-img14.png'),
    desc: 'Event planning & coordination'
  }, {
    image: require('../assets/images/services-img13.png'),
    desc: 'Travel planning & booking'
  }
]

const testimonyList = [
  {
    text: `I would like to sincerely thank you for the excellent work you have done in developing and maintaining the G-24 website.`,
    image: require('../assets/images/shichao-zhou.png'),
    name: 'Shichao Zhou',
    position: 'G-24 Secretariat, Research Officer'
  }, {
    text: "I have consistently record sales over the last couple months. So I just wanted to THANK YOU and tell you that do have done a great work for me. Thank you!!!",
    image: require('../assets/images/troy-parsons.png'),
    name: 'Troy Parsons',
    position: 'AAR Auto Glass, Owner'
  }, {
    text: "We love it, Client Loves it. Great work Dante! Keep them coming. Thanks for the hard work!",
    image: require('../assets/images/alan-thomas.png'),
    name: 'Alan Thomas',
    position: 'CloudCom USA, Project Manager'
  }
]

const plansInfo = [
  {
    image: require('../assets/images/plans-img-3.png'),
    title: 'Professional',
    subtitle: 'Lifetime Discount - Limited Time',
    price: '1800',
    discounted_price: '1400',
    range: true,
    type: 'discounted',
    desc: [
      {
        listInfo: '140 hours of task work per month',
      },
      {
        listInfo: '7-day money-back guarantee',
        description:
        <p>
          All monthly plans are eligible for a full refund within 7 business days. We make canceling your subscription simple. You can request to cancel within PayPal or contact our support team. We make cancellations simple because we rely on the quality of our service to keep you, not fine-prints.
        </p>
      },
      {
        listInfo: 'Dedicated assistant you will work with regularly',
      },
      {
        listInfo: 'Support from others for specialized tasks',
      },
       {
        listInfo: 'Real-time collaboration via Google Chat or Slack',
      },
      {
        listInfo: 'White-label option',
        description:
        <p>
          Branded to your agency with not a mention of Fullstack HQ anywhere.
        </p>
      },
      {
        listInfo: 'Upgrade, downgrade or cancel anytime',
        description:
        <p>
          You can upgrade or downgrade your subscription at any time by contacting us via chat or email. There is no contract for the subscription; you are free to cancel and re-subscribe whenever you want.
        </p>
      }
    ],
    buttonText: 'Choose plan',
    variant: 'normal',
    buttonLink: 'https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-5B7462042K468943TMLFVO4I',
    buttonBeacon: false,
    buttonExternal: true
  },
  {
    image: require('../assets/images/plans-img-2.png'),
    title: 'Starter',
    subtitle: 'Lifetime Discount - Limited Time',
    price: '1200',
    discounted_price: '960',
    range: true,
    type: 'discounted',
    desc: [
      {
        listInfo: '80 hours of task work per month',
      },
      {
        listInfo: '7-day money-back guarantee',
        description:
        <p>
          All monthly plans are eligible for a full refund within 7 business days. We make canceling your subscription simple. You can request to cancel within PayPal or contact our support team. We make cancellations simple because we rely on the quality of our service to keep you, not fine-prints.
        </p>
      },
      {
        listInfo: 'Dedicated assistant you will work with regularly',
      },
      {
        listInfo: 'Support from others for specialized tasks',
      },
       {
        listInfo: 'Real-time collaboration via Google Chat or Slack',
      },
      {
        listInfo: 'White-label option',
        description:
        <p>
          Branded to your agency with not a mention of Fullstack HQ anywhere.
        </p>
      },
      {
        listInfo: 'Upgrade, downgrade or cancel anytime',
        description:
        <p>
          You can upgrade or downgrade your subscription at any time by contacting us via chat or email. There is no contract for the subscription; you are free to cancel and re-subscribe whenever you want.
        </p>
      }
    ],
    buttonText: 'Choose plan',
    variant: 'normal',
    buttonLink: 'https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-3JH50624SL218203DMRIKYTA',
    buttonBeacon: false,
    buttonExternal: true
  },
  {
    image: require('../assets/images/plans-img-1.png'),
    title: 'Basic',
    subtitle: 'Lifetime Discount - Limited Time',
    price: '720',
    discounted_price: '600',
    range: true,
    type: 'discounted',
    desc: [
      {
        listInfo: '40 hours of task work per month',
      },
      {
        listInfo: '7-day money-back guarantee',
        description:
        <p>
          All monthly plans are eligible for a full refund within 7 business days. We make canceling your subscription simple. You can request to cancel within PayPal or contact our support team. We make cancellations simple because we rely on the quality of our service to keep you, not fine-prints.
        </p>
      },
      {
        listInfo: 'Dedicated assistant you will work with regularly',
      },
      {
        listInfo: 'Support from others for specialized tasks',
      },
       {
        listInfo: 'Real-time collaboration via Google Chat or Slack',
      },
      {
        listInfo: 'White-label option',
        description:
        <p>
          Branded to your agency with not a mention of Fullstack HQ anywhere.
        </p>
      },
      {
        listInfo: 'Upgrade, downgrade or cancel anytime',
        description:
        <p>
          You can upgrade or downgrade your subscription at any time by contacting us via chat or email. There is no contract for the subscription; you are free to cancel and re-subscribe whenever you want.
        </p>
      }
    ],
    buttonText: 'Choose plan',
    variant: 'normal',
    buttonLink: 'https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-1DE01793AR436194JMNVSXAI',
    buttonBeacon: false,
    buttonExternal: true
  }
]

const cta = {
  hasBackground: false,
  hasButton: true,
  imagePrimary: true,
  title: 'Virtual Assistant Services',
  desc: `Get reliable, skilled virtual assistants who handle routine and specialized tasks, so you can save time, reduce your workload, and focus on what matters most.`,
  image: require('../assets/images/banner-maintenance.png'),
  buttons: [
    {
      type: 'normal',
      text: 'Book a call',
      link: 'https://calendly.com/fullstackhq/meeting',
      beacon: false,
      external: true
    }, {
      type: 'outline',
      text: 'Chat with us',
      link: '/',
      beacon: true
    }
  ]
}

function VirtualAssistant() {
  return (
    <>
      <OgTags
        ogTitle="Virtual Assistant Services for Businesses | Fullstack HQ"
        ogDescription="Save time and get more done with reliable virtual assistant services from Fullstack HQ. Get skilled, tech-savvy VAs to support your business and daily operations."
        ogUrl="https://fullstackhq.com/virtual-assistant"
      />
      <Header />
      <main className="design initialized-header">
        <ContentImage content={ cta }  />
        <Brands
          text="Some of the brands we work with..."
          brands={ logo }
        />
        <Services
          heading="What we do"
          services= { servicesInfo }
        />
        <Testimonials
          title="Loved by world-class entrepreneurs & tech companies"
          testimony={ testimonyList }
        />
        <Plan
          heading="Transparent & Simple Pricing"
          content={plansInfo}
        />
      </main>
      <Footer />
    </>
  )
}

export default VirtualAssistant

